var _path, _path2, _mask, _rect, _path3, _mask2, _rect2, _path4, _mask3, _rect3, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpwardTrendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 8.40757L6.30358 4.57878L8.59995 7.25893L16.501 1.125",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 0.75L16.5241 0.75L16.7572 0.75L16.7572 4.57879",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5972_5029",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 18.5312,
    width: 6.125,
    height: 6.125,
    rx: 1.125,
    transform: "rotate(-180 6.125 18.5312)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 18.5312,
    width: 6.125,
    height: 6.125,
    rx: 1.125,
    transform: "rotate(-180 6.125 18.5312)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_5972_5029)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M4.18164 14.3281V15.0781H1.74316V14.3281H4.18164Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_5972_5029",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.0156,
    y: 18.5312,
    width: 6.125,
    height: 7.65625,
    rx: 1.125,
    transform: "rotate(180 13.0156 18.5312)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0156,
    y: 18.5312,
    width: 6.125,
    height: 7.65625,
    rx: 1.125,
    transform: "rotate(180 13.0156 18.5312)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3,
    mask: "url(#path-5-inside-2_5972_5029)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M11.1719 12.8965V13.6465H8.7334V12.8965H11.1719Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 1.5
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_5972_5029",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9062,
    y: 18.5312,
    width: 6.125,
    height: 9.95312,
    rx: 1.125,
    transform: "rotate(180 19.9062 18.5312)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9062,
    y: 18.5312,
    width: 6.125,
    height: 9.95312,
    rx: 1.125,
    transform: "rotate(180 19.9062 18.5312)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3,
    mask: "url(#path-7-inside-3_5972_5029)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M18.0625 10.6465V11.3965H15.624V10.6465H18.0625Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardTrendIcon);
export default __webpack_public_path__ + "static/media/upward-trend-icon.f41458deff564b2f5a84021cb7222c23.svg";
export { ForwardRef as ReactComponent };